import { useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { ChevronRightIcon } from '@heroicons/react/24/solid'
import { GetOrganizationSettingsOptions } from 'functions/roleBasedAccessUtils'
import { Switch } from '@headlessui/react'
import { setAdminToolsVisible } from 'redux/slices/user'

import ScreenFrame from "components/Frame/ScreenFrame"
import ContentFrame from "components/Frame/ContentFrame"

export default function OrganizationSettings() {

    const dispatch = useDispatch()
    const navigate = useNavigate()

    const userType = useSelector((state) => state.user.type)
    const overrideOrganizationId = useSelector((state) => state.admin.overrideOrganizationId)
    const adminToolsVisible = useSelector((state) => state.user.adminToolsVisible)

    const ToggleAdminToolsVisible = () => {
        dispatch(setAdminToolsVisible(!adminToolsVisible))
    }

    return (
        <ScreenFrame>
            <div className='max-w-4xl mx-auto space-y-4'>
                <div className='flex items-center space-y-1 gap-x-2 pb-2'>
                    <h1 className="text-2xl font-semibold text-gray-900 tracking-tight pt-2 flex-grow">
                        Settings
                    </h1>
                </div>

                <ContentFrame className='divide-y divide-gray-200'>
                    {GetOrganizationSettingsOptions(userType).map((setting, index) => (
                        <div 
                            key={index}
                            className="w-full flex items-center px-6 py-4 gap-x-6 cursor-pointer hover:bg-gray-50 transition-all"
                            onClick={() => navigate(setting.route)}
                        >
                            <div className='flex-1 space-y-1'>
                                <div className="text-lg font-bold">{setting.title}</div>
                                <div className="text-sm text-gray-500">{setting.description}</div>
                            </div>

                            <ChevronRightIcon className="h-6 w-6 text-gray-400 group-hover:text-orange-500 transition-colors" />
                        </div>
                    ))}
                </ContentFrame>

                {overrideOrganizationId === null && userType === 'super-admin' && (
                    <ContentFrame>
                        <div 
                            className="w-full flex items-center px-6 py-4 gap-x-8 cursor-pointer hover:bg-gray-50 transition-colors"
                            onClick={ToggleAdminToolsVisible}
                        >
                            <div className="flex-grow">
                                <div className="text-lg font-semibold">Admin Tools</div>
                            </div>

                            <Switch
                                checked={adminToolsVisible}
                                className={`
                                    relative inline-flex h-6 w-11 flex-shrink-0 rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out
                                    ${adminToolsVisible ? 'bg-orange-400' : 'bg-gray-200'}
                                `}
                            >
                                <span
                                    aria-hidden="true"
                                    className={`
                                        pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out
                                        ${adminToolsVisible ? 'translate-x-5' : 'translate-x-0'}
                                    `}
                                />
                            </Switch>

                        </div>
                    </ContentFrame>
                )}

                <p className='pt-4 text-center text-gray-600'>
                    Have additional questions? Contact us at <a href="mailto:support@kinesisintegrated.com" className="text-blue-500 underline">support@kinesisintegrated.com</a>
                </p>
            </div>
        </ScreenFrame>
    )
}